export default __webpack_public_path__ + "static/media/trovityLogo.b6fc258a.svg";